import { ActionReducerMap } from '@ngrx/store';
import * as fromAuthentication from '../authentication/authentication.reducer';
import * as fromCourseCategory from '../calendar/courseCategory.reducer';
import * as fromCourse from '../calendar/course.reducer';
import * as fromRoom from '../calendar/room.reducer';
import * as fromInstructor from '../calendar/instructor.reducer';
import * as fromTrainingLevel from '../calendar/trainingLevel.reducer';
import * as fromContingentBundles from '../contingent/contingent-bundle.reducer';
import * as fromEvent from '../calendar/event.reducer';
import * as fromCustomization from '../customization/customization.reducer';
import * as fromUserManagement from '../user-management/user-management.reducer';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';

export interface State {
    [fromAuthentication.authenticationFeatureKey]: fromAuthentication.State;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    router: RouterReducerState<any>;
    [fromCourseCategory.courseCategoryFeatureKey]: fromCourseCategory.State;
    [fromCourse.courseFeatureKey]: fromCourse.State;
    [fromRoom.roomFeatureKey]: fromRoom.State;
    [fromInstructor.instructorFeatureKey]: fromInstructor.State;
    [fromTrainingLevel.trainingLevelFeatureKey]: fromTrainingLevel.State;
    [fromContingentBundles.contingentBundleFeatureKey]: fromContingentBundles.State;
    [fromEvent.eventFeatureKey]: fromEvent.State;
    [fromCustomization.customizationFeatureKey]: fromCustomization.State;
    [fromUserManagement.userManagementFeatureKey]: fromUserManagement.State;
}

export const reducers: ActionReducerMap<State> = {
    [fromAuthentication.authenticationFeatureKey]: fromAuthentication.reducer,
    router: routerReducer,
    [fromCourseCategory.courseCategoryFeatureKey]: fromCourseCategory.reducer,
    [fromCourse.courseFeatureKey]: fromCourse.reducer,
    [fromRoom.roomFeatureKey]: fromRoom.reducer,
    [fromInstructor.instructorFeatureKey]: fromInstructor.reducer,
    [fromTrainingLevel.trainingLevelFeatureKey]: fromTrainingLevel.reducer,
    [fromContingentBundles.contingentBundleFeatureKey]: fromContingentBundles.reducer,
    [fromEvent.eventFeatureKey]: fromEvent.reducer,
    [fromCustomization.customizationFeatureKey]: fromCustomization.reducer,
    [fromUserManagement.userManagementFeatureKey]: fromUserManagement.reducer
};
